<button
  class="button-bill"
  sdButton
  type="unset"
  size="unset"
  [disabled]="loading$ | async"
  (click)="onClickButtonBill()"
>
  <cx-icon type="DOWNLOAD"></cx-icon>
  <span>{{ large ? 'Скачать счёт' : 'Счёт' }}</span>
</button>
